import { useDispatch, useSelector } from "react-redux";

import { setCbtValue } from "../data/actions/cbt";
import { AppState } from "../data/reducers";

export function useCbtUpdateGuestCheckbox({ indexPassenger }) {
  const { guestsToUpdateInDynamicForm } = useSelector((state: AppState) => ({
    guestsToUpdateInDynamicForm: state.cbt.guestsToUpdateInDynamicForm,
  }));

  const dispatch = useDispatch();

  const isChecked =
    guestsToUpdateInDynamicForm &&
    guestsToUpdateInDynamicForm.includes(indexPassenger);

  const handleCheck = () => {
    const newGuestsToUpdateInDynamicForm = isChecked
      ? guestsToUpdateInDynamicForm.filter((index) => index !== indexPassenger)
      : (guestsToUpdateInDynamicForm || []).concat(indexPassenger);

    dispatch(
      setCbtValue("guestsToUpdateInDynamicForm", newGuestsToUpdateInDynamicForm)
    );
  };

  return { isChecked, handleCheck };
}
